<template>
  <div>
    <v-card
      class="rounded-lg mt-3 premium-list-card"
      @click="
        havePermissionGetOrUpdateTraining
          ? navigateToCourseDetailsPage(course._id)
          : null
      "
    >
      <v-row align="center">
        <v-col cols="12" sm="6" md="4">
          <div class="font-weight-light">
            <div class="d-flex flex-row justify-start flex-md-row align-center">
              <v-img
                :key="`course-card_${course._id}`"
                class="rounded-lg ms-3"
                height="60"
                max-width="90"
                :src="course.images ? getImage(course.images) : null"
                lazy-src="@/app/core-module/assets/images/logo_placeholder.png"
                cover
              />

              <div
                class="ms-3 me-0 me-md-3 align-center"
                style="text-align: start"
              >
                <span
                  class="text-left subtitle-1 textLight--text text-ellipse-2"
                >
                  {{ getLocalisedValue(course.title) }}
                </span>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <span
            class="
              text-left
              subtitle-1
              textLight--text
              text-ellipse-2
              ps-3 ps-sm-0
            "
          >
            {{
              course.createdBy && course.createdBy.firstName
                ? course.createdBy.firstName
                : "-"
            }}

            <span v-if="course.createdBy && course.createdBy.lastName">
              {{ course.createdBy.lastName }}
            </span>
          </span>
        </v-col>

        <v-col cols="6" sm="6" md="2">
          <span
            class="
              text-left
              subtitle-1
              textLight--text
              text-ellipse-2
              ps-3 ps-sm-3 ps-md-0
            "
          >
            {{
              course.trainingCategories && course.trainingCategories.length
                ? getLocalisedValue(course.trainingCategories[0].name)
                : "-"
            }}
          </span>
        </v-col>

        <v-col cols="6" sm="6" md="2">
          <span class="text-left subtitle-1 textLight--text text-ellipse-2">
            {{
              course.trainingSubCategories &&
              course.trainingSubCategories.length
                ? getLocalisedValue(course.trainingSubCategories[0].name)
                : "-"
            }}
          </span>
        </v-col>

        <v-col cols="12" sm="12" md="2">
          <div class="d-flex justify-space-between align-center">
            <span
              class="
                text-start
                subtitle-1
                textLight--text
                text-ellipse-2
                flex-grow-1
                ps-3 ps-sm-3 ps-md-0
              "
            >
              {{
                course.price
                  ? `${course.price} ${$store.getters.currency}`
                  : "-"
              }}
            </span>

            <v-menu
              v-if="
                havePermissionEnableDisableTraining ||
                havePermissionDeleteTraining
              "
              class="flex-grow-1"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <template v-for="(item, i) in items">
                  <v-list-item
                    v-if="
                      (item.value !== 'delete' &&
                        havePermissionEnableDisableTraining) ||
                      (item.value === 'delete' && havePermissionDeleteTraining)
                    "
                    :key="i"
                    class="hand-cursor"
                  >
                    <v-list-item-title @click="updateOrDelete(item.value)">
                      <div class="d-flex justify-space-between">
                        <v-icon
                          size="18"
                          :color="item.iconColor"
                          class="me-2"
                          >{{ item.icon }}</v-icon
                        >
                        {{ item.text }}
                      </div>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { updateTrainingStatus } from "../methods/updateTrainingStatus";
import { deleteTraining } from "../methods/deleteTraining";
import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    items() {
      return [
        !this.course.isActive
          ? {
              icon: "mdi-check-circle-outline",
              iconColor: "green",
              text: "Enable",
              value: "enable",
            }
          : {
              icon: "mdi-cancel",
              iconColor: "",
              text: "Disable",
              value: "disable",
            },
        {
          icon: "mdi-trash-can-outline",
          iconColor: "red",
          text: "Delete",
          value: "delete",
        },
      ];
    },
    havePermissionGetOrUpdateTraining() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["GET_TRAININGS", "UPDATE_TRAINING"],
        requiredAll: false,
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionEnableDisableTraining() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["ENABLE_DISABLE_TRAINING"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionDeleteTraining() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["DELETE_TRAINING"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  methods: {
    navigateToCourseDetailsPage(trainingId) {
      this.$router.push({
        name: "CourseDetails",
        params: { trainingId },
      });
    },
    async updateOrDelete(val) {
      if (val) {
        if (val === "enable") {
          await updateTrainingStatus({
            id: this.course._id,
            isActive: true,
          }).then(res => {
            this.$emit("statisticsCardReRender");
            this.$emit("coursesListReRender");
          });
        } else if (val === "disable") {
          await updateTrainingStatus({
            id: this.course._id,
            isActive: false,
          }).then(res => {
            this.$emit("statisticsCardReRender");
            this.$emit("coursesListReRender");
          });
        } else if (val === "delete") {
          const msg =
            this.$i18n.locale === "ar"
              ? "سيتم حذف هذه الدورة بشكل دائم ، هل أنت متأكد من المتابعة؟"
              : "This course will be deleted permanently. Are you sure to continue?";

          this.$dialog
            .confirm(msg)
            .then(() => {
              deleteTraining(this.course._id).then(res => {
                this.$emit("statisticsCardReRender");
                this.$emit("coursesListReRender");
              });
            })
            .catch(_ => {});
        }
      }
    },
  },
};
</script>

<style scoped>
.premium-list-card {
  background-color: white !important;
  border: 1px solid #edf2f9 !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02) !important;
  transition: all 0.2s ease-in-out;
}
.premium-list-card:hover {
  border-color: #d8e2ef !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
  transform: translateY(-1px);
}
</style>
